import {
  AppBar,
  Box,
  Button,
  Card,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import HeadNav from "../components/common/HeadNav";
import Reset from "../components/auth/Reset";
import products from "../constants/products";
import { Stack } from "@mui/system";
import { Link } from "react-router-dom";
import background from "../assets/images/Login.svg";

const ResetPassword = () => {
  return (
    <>
      <HeadNav />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100vh",
          // backgroundColor: "#f7f9fc",
          justifyContent: "center",
          width: "100vw",
          backgroundImage: `url(${background})`,
          backgroundSize: "100% 90vh",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center bottom",
        }}
      >
        <Box
          sx={{
            p: { sm: 5 },
            gap: 4,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Card
            sx={{
              p: { xs: "10px 20px", sm: "40px 60px" },
              width: { xs: "100%", sm: "450px" },
              borderRadius: { sm: 5 },
              boxShadow:
                "0px 8px 24px rgba(88, 101, 242, 0.15), 0rem 0rem 20rem 6rem #f7f9fc",
              // boxShadow: "0rem 0rem 20rem 6rem #f7f9fc",
            }}
          >
            <Stack spacing={5} sx={{ m: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: 1,
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.875rem",
                    color: "#212121",
                    letterSpacing: "0.015625rem",
                  }}
                >
                  Reset Password
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    color: "#6A6A6A",
                    letterSpacing: "0.009375rem",
                  }}
                >
                  Enter your Email ID
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <Reset />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  fontWeight: 400,
                  fontSize: "0.875rem",
                  letterSpacing: "0.009375rem",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                <Typography sx={{ color: "#212121",}}>
                  Not Registered Yet?
                </Typography>
                <Link to={products.WEBSITE + "/onboarding"} target="_blank" rel="noopener noreferrer">
                  <Typography
                    sx={{
                      color: "#5865F2",
                      marginLeft: "0.2rem",
                    }}
                  >
                    Create an account
                  </Typography>
                </Link>
              </Box>
            </Stack>
          </Card>
        </Box>
      </Box>
    </>
  );
};

export default ResetPassword;
